import z from "zod/v4";

import { PerformanceByColorSchema } from "./performance-by-color-model";
import { PerformanceModelSchema } from "./performance-model";

export const STATS_VERSION = 2;

export const RatingDataPointSchema = z.object({
    timestamp: z.number(),
    rating: z.number(),
});

export type RatingDataPoint = z.infer<typeof RatingDataPointSchema>;

export const ChessStatsByTypeSchema = z.object({
    type: z.string(),
    currentRating: z.number(),
    highestRating: z.number(),
    highestRatingGameId: z.string(),
    lowestRating: z.number(),
    lowestRatingGameId: z.string(),
    performanceByColor: PerformanceByColorSchema,
    totalPerformance: PerformanceModelSchema,
    ratedPerformance: PerformanceModelSchema,
    lastUpdated: z.number(),
    totalGames: z.number(),
    ratingHistory: z.array(RatingDataPointSchema),
});

export type ChessStatsByType = z.infer<typeof ChessStatsByTypeSchema>;

export const ChessStatsSchema = z.object({
    collectionId: z.string(),
    version: z.number(),
    statsByType: z.array(ChessStatsByTypeSchema),
    totalGames: z.number(),
    totalRatedGames: z.number(),
    totalUnratedGames: z.number(),
    totalPerformance: PerformanceModelSchema,
    performanceByColor: PerformanceByColorSchema,
    ratedPerformance: PerformanceModelSchema,
    highestRating: z.number(),
    highestRatingGameId: z.string(),
    lowestRating: z.number(),
    lowestRatingGameId: z.string(),
});

export type ChessStats = z.infer<typeof ChessStatsSchema>;
